import { dealModel, DealRecord } from "@/models/deal";
import { financialDeckModel } from "@/models/financialDecks";
import { userIsCreatorConstraint } from "@/orm/model";
import { Route } from "@/paths";
import { CustomCellRendererProps } from "@ag-grid-community/react";
import { Anchor, Group } from "@mantine/core";
import { useAtomValue } from "jotai";
import { useMemo } from "react";

export const DealRenderer = (props: CustomCellRendererProps) => {
  const financialDeckEntity = financialDeckModel.createEntityInstance({
    id: props.data.id,
  });

  const observeAtom = useMemo(() => {
    return financialDeckEntity.getObserveManyOwnersAtom<DealRecord>(
      dealModel,
      "belongsToDealIds",
      {
        constraints: [userIsCreatorConstraint()],
      },
    );
  }, []);

  const { entities: dealEntites } = useAtomValue(observeAtom);

  return (
    <Group>
      {dealEntites?.map(({ data: deal, id }) => (
        <Anchor
          inherit
          underline="always"
          href={Route.Deal.replace(":dealId", id || "missing-deal-id")}
          key={id}
        >
          {deal?.companyName || "Untitled Deal"}
        </Anchor>
      ))}
    </Group>
  );
};
